import './GameBoardBlockTray.css';
import { useGlobalState } from '../../../GlobalState';
import { Block } from '../../Block/Block';
import { v4 as uuidv4 } from 'uuid';

/**
 * Mostly defined 
 * @returns 
 */
export function GameBoardBlockTray() {

    //const TRAY_BLOCK_COUNT = 3;
    const { blocks } = useGlobalState();


    return (
        <div className="BlockTray">
            {blocks}
        </div>
    );
}
